export default __webpack_public_path__ + "static/mobile-f51fb1a50e79d99daf21b8a153eaecd6.webp";